import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class BackupService {

  constructor(private http: HttpClient,private env: EnvService) {

  }



  getAll():Observable <any[]> {
   return this.http.get<any[]>(`${this.env.apiUrl}/db-backup`,httpOptions)
   .pipe(catchError(this.handleError));
      
   }


   createBackup(data):Observable <any>{
     return this.http.post<any>(`${this.env.apiUrl}/db-backup`,data ,httpOptions)
       .pipe(catchError(this.handleError));
      
   }

   downloadFile(filename:String){
     return this.http.get(`${this.env.apiUrl}/db-backup/${filename}`,{
         responseType : 'blob',
         headers:new HttpHeaders().append('Content-Type','application/json')
     })
     .pipe(catchError(this.handleError));
   }

   restoreBackup(filename:string):Observable <any>{
       return this.http.post<any>(`${this.env.apiUrl}/db-backup/${filename}`, httpOptions)
         .pipe(catchError(this.handleError));
        
     }


   deleteBackup(filename:string) : Observable <void>{
     return this.http.delete<void>(`${this.env.apiUrl}/db-backup/${filename}`,httpOptions)
       .pipe(catchError(this.handleError));
      
   }



   private handleError(errorResponse: HttpErrorResponse) {
     return throwError(errorResponse || "Server Error");

     }
     
    }
